import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LoyaltyBenefitIcon from 'loyalty/components/LoyaltyBenefitIcon'
import { formatBenefitLabel } from 'loyalty/utils/loyaltyBenefitLabels'
import { setSvgIconSize } from 'LuxKit/SvgIcon'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { tierDarkBackgroundStyle, tierDarkContrastColorStyle, tierGradientBackgroundStyle, tierNormalContrastColorStyle } from 'styles/utils/tierStyles'

const Card = styled.div`
  background-color: ${props => props.theme.palette.neutral.default.eight};
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
  border-radius: ${rem(8)};
  overflow: hidden;
`

const CardHeader = styled.div`
  padding: ${rem(16)} ${rem(24)};
  ${tierGradientBackgroundStyle}
  ${tierNormalContrastColorStyle}
`

const CardBody = styled.div`
  padding: ${rem(16)} ${rem(24)};
  color: ${props => props.theme.palette.neutral.default.one};
  display: flex;
  flex-direction: column;
  gap: ${rem(8)};
`

const BenefitItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(8)};
`

const BenefitIconContainer = styled.div`
  flex-shrink: 0;
  display: grid;
  place-items: center;
  height: ${rem(20)};
  width: ${rem(20)};
  border-radius: ${props => props.theme.borderRadius.round};
  ${setSvgIconSize(15)}
  ${tierDarkBackgroundStyle}
  ${tierDarkContrastColorStyle}

  ${mediaQueryUp.tablet} {
    height: ${rem(24)};
    width: ${rem(24)};
  }
`

interface Props {
  tier: App.LoyaltyTier
  title: string
  subtitle?: string
  benefits: Array<App.LoyaltyRegionTierBenefit>
}

function TierUpgradeCampaignTierCard(props: Props) {
  const intl = useIntl()
  const { tier, title, subtitle, benefits } = props

  const viewAllBenefitsText = intl.formatMessage({
    id: 'LcqBlKTsUNqtG89VNCFo',
    defaultMessage: 'View all benefits',
    description: 'Link text to view the full list of loyalty tier benefits',
  })

  const tierClass = `tier-${tier}`

  return <Card>
    <CardHeader className={tierClass}>
      <Heading variant="heading5">{title}</Heading>
    </CardHeader>
    <CardBody>
      <VerticalSpacer gap={12}>
        {subtitle && <BodyText variant="medium">{subtitle}</BodyText>}
        <VerticalSpacer gap={4}>
          {benefits.map(benefit => {
            const label = formatBenefitLabel(intl, benefit)
            if (!label) return null
            return <BenefitItem key={benefit.code}>
              <BenefitIconContainer className={tierClass}>
                <LoyaltyBenefitIcon benefitType={benefit.code} />
              </BenefitIconContainer>
              <BodyText variant="medium" colour="neutral-two">{label}</BodyText>
            </BenefitItem>
          })}
        </VerticalSpacer>
      </VerticalSpacer>
      <TextLink size="medium" href="#about-benefits">{viewAllBenefitsText}</TextLink>
    </CardBody>
  </Card>
}

export default TierUpgradeCampaignTierCard
